import { FC } from 'react'
import { Provider } from 'react-redux'

import AppRouter from 'navigation/AppRouter'
import { ChakraProvider, theme } from '@chakra-ui/react'
import store from 'model/store'

const App: FC<{}> = () => {
  return (
    <Provider store={store}>
      <ChakraProvider theme={theme}>
        <AppRouter />
      </ChakraProvider>
    </Provider>
  )
}

export default App
